import React from 'react';

interface RangeSliderProps {
  value: number;
  onChange: (value: number) => void;
  labels: Record<number, string>;
}

export default function RangeSlider({ value, onChange, labels }: RangeSliderProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(Number(e.target.value));
  };

  return (
    <div className="w-full">
      <div className="relative h-3 mb-4">
        {/* Background bar */}
        <div className="absolute inset-0 bg-gray-200 rounded-full" />
        
        {/* Progress bar with gradient */}
        <div
          className="absolute inset-0 rounded-full transition-all duration-300"
          style={{
            width: `${value}%`,
            background: 'linear-gradient(to right, #2A4365, #4A5568, #C4A052)'
          }}
        />

        {/* Dots */}
        <div className="absolute inset-0 flex justify-between items-center px-1">
          {[0, 25, 50, 75, 100].map((point) => (
            <div
              key={point}
              className="w-5 h-5 rounded-full border-2 transition-all duration-300"
              style={{
                background: point <= value 
                  ? 'linear-gradient(to right, #2A4365, #4A5568, #C4A052)'
                  : '#E5E7EB',
                borderColor: point <= value ? '#2A4365' : '#9CA3AF'
              }}
            />
          ))}
        </div>

        <input
          type="range"
          min={0}
          max={100}
          value={value}
          onChange={handleChange}
          step={25}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        />
      </div>

      <div className="flex justify-between mt-2">
        {[0, 25, 50, 75, 100].map((point) => (
          <span
            key={point}
            className={`text-sm ${
              point === value ? 'text-[#2A4365] font-medium' : 'text-gray-500'
            }`}
          >
            {labels[point]}
          </span>
        ))}
      </div>
    </div>
  );
}